import { MenuMeses } from "./style.js";
import LabelMes from "../LabelMes/LabelMes.jsx";
import { useEffect } from "react";

export default function MenuMesesLouvor(props) {

  return (
    <MenuMeses>
      {props.meses.map((mes, i) => (
        <LabelMes
          key={i}
          onClick={() => props.toggleMes(mes.mes)}
          size={"small"}
          mes={mes.mes}
          variant="contained"
          className={
            props.mesesSelecionados.includes(mes.mes) ? "active" : ""
          }
        />
      ))}
    </MenuMeses>
  );
}
